<template>
    <div>
        <table>
            <colgroup>
                <col/>
            </colgroup>
            <tbody>
            <tr v-bind:key="index" v-for="(item, index) in items" >
                <td>
                    <div>
                        <span>
                            <input :id="'cp_' + index" :value="item.rentalcompanyId" type="checkbox" v-model="context.checkItems">
                            <label :for="'cp_' + index"><span></span></label>
                        </span>
                        <span>{{item.rentalcompanyName}}</span>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {PATH} from "@/constants";
    export default {
        name: "MonitoringAgentFileUploadStep2",
        props: {
            value: {type: Object, default: undefined},
        },
        data: function () {
            return {
                items: [],
                checkItems: [],
                context: this.value,
            };
        },
        created() {
            this.init();
        },
        watch:{
            context:{
                deep: true,
                handler: function (newValue, oldValue) {
                    this.$emit('input', this.context)
                }
            }
        },
        methods: {
            init(){
                this.load()
            },

            async load(){
                const res = await this.$request(PATH.MONITORING.RENTALCOMPANY_LIST)
                    .post()
                    .enqueue();
                this.items = res.data;
            },
        },
    }
</script>

<style scoped>

</style>